<template>
<main class="group__main">
    <div class="group__main__content">
        <SidebarDefault />

        <router-view />
    </div>
</main>
</template>


<script setup>
import SidebarDefault from '@/components/Sidebar/SidebarDefault.vue'
</script>